import {distanceConverter} from '../../../lib/anuket';
import {connectStream} from '../../../lib/bastetjs/utils/connectStream';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withTranslation} from 'react-i18next';
import {
  getMedia,
  getMediaStop,
  getDisplayLocationString
} from 'athlinks-results-client';
import {convertPace, convertTime, convertCalendarTime, getPaceFromUnitType, UnitType } from 'lib-athlinks-units';
import {connect} from 'react-redux';
import {compose} from 'redux';
import _ from 'lodash';
import Style from 'style-it'

import {IndividualPhotoGrid} from '../IndividualPhotoGrid';
import {IRPRaceDetails} from './IRPRaceDetails';
import {HeroCardAllDivisions} from '../heroCard/AllDivisions';
import {AthleteCard} from '../heroCard/AthleteCard';
import {isLoggedIn, getTokenRacerId} from '../../../utils/isLoggedIn';
import {FriendsRacing} from '../../ELP/friendsRacing/FriendsRacing';
import {EventResultsStreams} from '../../../data/EventResultsStreams';
import {AthlinksAds} from '../../shared/Banner';
import {getResultsUrl} from '../../../utils/resultsHelpers';
import {styles, splitTable} from './styles';
import {getGender} from '../heroCard/helpers';
import {
  fetchFollowers,
  getFollowersStream
} from '../../../data/ProfileStreams';
import { isAFriend } from '../../../shared/util';
import {
  fetchAthlete,
} from '../../../data/AthleteStreams';
import {fetchPendingClaims, getPendingClaims} from '../../../data/UnclaimedSearchStreams';
import {ClaimResultButton} from '../../control/ClaimResult';
import {SocialShare} from '../../shared/SocialShare';
import {
  fetchFinisherCertificateUrl,
  getFinisherCertificateUrl
} from '../../../data/FinisherCertificateApi';
import { OpenGraphTags } from '../../../shared/OpenGraphTags';
import { StandardHeaderTags } from '../../../shared/StandardHeaderTags';
import {
  getBracketResults,
  getFullInterval,
  getLatestScoredInterval,
  getTime,
  isDNF,
  isDQ,
  isUnranked,
  shouldShowRankings,
  resolveClaimButtonProps,
  getOgTags,
  showPace,
  getTimeLabel
} from '../../../utils/IRPUtil';
import {isGunTime} from '../../../utils/ERPUtil';
import {RaceSummary} from './IRPRaceSummary';
import {EventHeader} from './IRPEventHeader';
import {FinalTime} from './IRPFinalTime';
import {Promo} from './IRPPromo';
import {
  getPendingStatusForResult,
  hasResultInEventCourse,
  getClaimStatusMessage,
  getClaimStatusDescription
} from '../../../utils/ClaimUtil';
import {getAthleteRacesStream, fetchAthleteRaces} from '../../../data/AthleteStreams';
import {HelpIcon} from '../../shared/icons';
import {Tooltip} from '../../tooltip/Tooltip';
import {Loading} from '../../shared/Loading';
import {setGlobalUnitTypeToMetric, setGlobalUnitTypeToImperial, setGlobalUnitTypeToDefault } from '../../../utils/setGlobalUnitType';
import {ClaimActionTypes as ClaimAction} from '../../../actions/types';
import {configs} from '../../../configs'
import {mapCheckAction} from '../../../actions/mapTrackingAction'

const mapStateToProps = (state) => ({
  mediaArgs: state.media.args,
  media: state.media.media,
  mediaIsLoading: state.media.isLoading,
  mapTracking: state.mapTracking,
  unitType: state.userPrefs.globalUnitType,
  dispatch: undefined
});

const shouldShowOnMobile = () => window.innerWidth < 600;

export class IRPBodyContainerComponent extends Component {
  static propTypes = {
    event: PropTypes.object,
    result: PropTypes.object,
    isMobile: PropTypes.bool,
    friends: PropTypes.object,
    sponsorLogos: PropTypes.array,
    image: PropTypes.object.isRequired,
    pendingClaims: PropTypes.object,
    certificateUrl: PropTypes.object,
    t: PropTypes.func
  };

  static defaultProps = {
    splitsContent: {isLoading: true},
    isMobile: false,
    sponsorLogos: [],
    certificateUrl: {fetching: true}
  };

  constructor(props, context) {
    super(props, context);
    this.state = {};
    AthlinksAds.init();
  }

  getPaceAdjustedFromUnitType() {
    const {
      result: {
        intervals
      },
      unitType
    } = this.props
    const latestInterval = getLatestScoredInterval(intervals);
    return getPaceFromUnitType(latestInterval.pace, unitType)
  }

  componentDidMount() {
    const {
      dispatch,
      event: {
        athlinksId,
        ctliveId
      },
      result: {
        bib,
        racerId,
        entryId,
        eventCourseId,
        thirdPartyEntryId
      },
      t
    } = this.props;

    dispatch(mapCheckAction(eventCourseId))

    const loggedInId = getTokenRacerId();

    if (racerId){
      if (entryId) {
        EventResultsStreams.setLegacyEntryResult(racerId, entryId);
      }
      fetchAthlete(racerId);
    }

    if (loggedInId) {
      fetchFollowers('followers', loggedInId);
    }

    fetchPendingClaims();
    if (ctliveId && eventCourseId && thirdPartyEntryId) {
      dispatch(getMedia(Object.assign(
        {},
        {eventId: ctliveId, eventCourseId, ctEntryId: thirdPartyEntryId},
        bib ? {bib} : {}
      ), 60 * 1000))
    }

    fetchFinisherCertificateUrl(
      bib,
      athlinksId,
      eventCourseId,
      entryId,
      thirdPartyEntryId,
      t
    );
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {result} = this.props;
    const {racerId, entryId} = result;

    const nextResults = nextProps && nextProps.result;

    if(racerId && nextResults
               && nextResults.racerId
               && entryId
               && nextResults.entryId
               && entryId !== nextResults.entryId) {
      EventResultsStreams.setLegacyEntryResult(nextProps.result.racerId,  nextProps.result.entryId);
    }

    if(!_.isEqual(this.props.pendingClaims, nextProps.pendingClaims)) {
      const pClaims = nextProps.pendingClaims;
      const claimStatus = pClaims && !pClaims.fetching && getPendingStatusForResult(pClaims.result, result);

      this.setState({
        claimStatus
      });
    }

    // we call this so we can tell if the user has a result for this event course
    if(!this.props.athleteRaces && (nextProps.athleteRaces || {}).fetching) {
      fetchAthleteRaces(getTokenRacerId());
    }
    // figure out if the user has a result in this event course
    if(!_.isEqual(this.props.athleteRaces, nextProps.athleteRaces) &&
      nextProps.athleteRaces && !nextProps.athleteRaces.fetching && !_.isEmpty(nextProps.athleteRaces.races) &&
      result.eventCourseId) {
      this.setState({
        claimedResultInEventCourse: hasResultInEventCourse(nextProps.athleteRaces.races, result.eventCourseId)
      });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {

    return !_.isEqual(this.props, nextProps) ||
      this.state.claimStatus !== nextState.claimStatus ||
      this.state.claimedResultInEventCourse !== nextState.claimedResultInEventCourse ||
      this.props.undefined!== nextState.unitType;
  }

  componentWillUnmount() {
    const {
      event: {
        ctliveId
      },
      result: {
        eventCourseId
      },
      mediaArgs,
      dispatch
    } = this.props;

    if (ctliveId && eventCourseId && mediaArgs) {
      dispatch(
        getMediaStop(Object.assign({}, {eventId: ctliveId, eventCourseId}, mediaArgs))
      )
    }
  }

  getStartTime = () => {
    const {
      result: {racerStartTime, thirdPartyEntryId}
    } = this.props;

    const {timeInMillis, timeZone} = racerStartTime;
    if (timeInMillis > 0 && timeZone && thirdPartyEntryId) {
      const time = convertCalendarTime(racerStartTime, {capitalize: true, timeFormat: 'h:mm:ss'});
      if(time.time) {
        return [time.time, time.meridiem, time.timeZone];
      }
    }
    return null;
  };

  getFinalTime = () => {
    const {
      result,
      result: {entryStatus},
      t
    } = this.props;

    if(isDQ(entryStatus)) {
      return t('disqualified');
    }
    else if(isDNF(entryStatus)) {
      return t('did not finish');
    }

    const finalInterval = getLatestScoredInterval(result.intervals);
    return getTime(finalInterval, isGunTime(finalInterval.brackets))
  };

  /**
   * Get latest rankings.
   * Wait for results to load. We find latest
   * interval that has ranks and use those values
   * @return {*}
   */
  getLatestRankings = () => {
    const {
      result
    } = this.props;

    const latestInterval = getLatestScoredInterval(result.intervals);
    if (!latestInterval || _.isEmpty(latestInterval.brackets)) {
      return [];
    }
    else {
      return getBracketResults(latestInterval.brackets);
    }
  };

  getRankingTitle = () => {
    const {
      result: {intervals, isLoading, isLive},
      t
    } = this.props;

    if(!isLoading && isLive) {
      const interval = getLatestScoredInterval(intervals);
      const {intervalId: id, intervalName: name} = interval;
      const intervalName = id === 'finish' ? t('Finish') : name;

      return `${t('Ranking {{interval}}', {interval: intervalName})}`;
    }

    return t('Ranking');
  };

  claimCallback = (isClaimed) => {
    const {
      result
    } = this.props;

    this.props.dispatch({
      type: ClaimAction.AFTER_CLAIM_INDIVIDUAL_RESULTS_UPDATE,
      racerId: isClaimed ? getTokenRacerId() : 0
    })

    EventResultsStreams.fetchEntryResultByEventId(result);
    fetchAthleteRaces(getTokenRacerId(), true);
    fetchPendingClaims();
  };

  onImperialViewClicked = _.flow(
    () => this.props.unitType === UnitType.IMPERIAL ? setGlobalUnitTypeToDefault : setGlobalUnitTypeToImperial,
    (action) => action(this.props.dispatch)
  )

  onMetricViewClicked = _.flow(
    () => this.props.unitType === UnitType.METRIC ? setGlobalUnitTypeToDefault : setGlobalUnitTypeToMetric,
    (action) => action(this.props.dispatch)
  )

  renderMapTracking = () => {

    const {
      result: {eventId, eventCourseId, thirdPartyEntryId},
    } = this.props;

    const mapUrl = `${configs.mapTrackingUrl}/map?event-id=${eventId}` +
       `&event-course-id=${eventCourseId}&entry-id=${thirdPartyEntryId}` +
       `&referrer=IRP`

    return (
      <div style={styles.mapTrackingContainer}>
        <div className="row">
          <div className='col-8' style={{paddingTop: 10}}>
            <span style={styles.mapTrackBetaBadge}>BETA</span>
            FOLLOW PROGRESS ON COURSE
          </div>
          <div className='col-4'>
            <a style={styles.viewMapBtn} target='_blank' href={mapUrl}>
              View On Map <span style={{marginLeft: 15}}>></span>
            </a>
          </div>
        </div>
      </div>
    )
  }

  render() {
    const {
      athleteId,
      certificateUrl,
      event = {},
      friends,
      image,
      isMobile,
      media,
      mediaIsLoading,
      mapTracking: {mapPresent},
      race,
      result,
      result: {entryStatus},
      sponsorLogos,
      t
    } = this.props;

    const {intervals = [], isLive} = result;

    const {
      claimStatus,
      claimedResultInEventCourse
    } = this.state;

    const usingGunTime = isGunTime(getLatestScoredInterval(result.intervals).brackets || []);
    const latestTime = this.getFinalTime();

    const loggedIn = isLoggedIn();
    const tokenRacerId = getTokenRacerId();
    const isFriend = friends && !friends.fetching && isAFriend(friends.list, result.racerId);
    const isMe = tokenRacerId === parseInt(result.racerId);

    const gender = result && getGender(result.gender, t);

    const resultLocation = result && getDisplayLocationString(result.locality, result.region, result.country);
    const resultsUrl = getResultsUrl(event.masterId, event.athlinksId, this.props.race[0].eventCourseId);
    const entryIsTeam = result.entryType === 'TEAM';
    const showRankings = shouldShowRankings(entryStatus);
    const latestInterval = getLatestScoredInterval(intervals);
    const shouldShowPace = showPace(latestInterval.pace);

    const latestIntervalName = latestInterval.intervalName;
    const timeLabel = getTimeLabel(result, usingGunTime, t);

    const fullInterval = getFullInterval(result.intervals);
    const altTime = convertTime(usingGunTime
      ? {...fullInterval.chipTime, timeUnit: 'h'}
      : {...fullInterval.gunTime, timeUnit: 'h'}
    ).value;

    const paceAdjustedForUser = this.getPaceAdjustedFromUnitType()
    const pace = shouldShowPace ? convertPace(paceAdjustedForUser) : { value: 0, label: '' };

    const adUnits = AthlinksAds.adsForPage('IndividualResults');
    const {ogTitle, ogDescription, ogImage} = getOgTags(result, certificateUrl, image, t);

    const buttonsProps = {
      event,
      isMobile
    };

    const toDistanceType = this.props.unitType === UnitType.METRIC ? 7 : 1
    const distance = distanceConverter.distanceTo(race[0].meters, 6, toDistanceType).toFixed(1)

    const claimButtonProps = resolveClaimButtonProps(athleteId, result, isMobile, isLive,
      event, resultLocation, loggedIn, isMe, claimStatus, claimedResultInEventCourse, this.claimCallback, latestTime, t);

    const imperialButtonStyles = this.props.unitType === UnitType.IMPERIAL
                                 ?  { ...styles.imperialButtonStyles, ...styles.metricImperialActiveButton }
                                 : styles.imperialButtonStyles

    const metricButtonStyles = this.props.unitType === UnitType.METRIC
                               ? { ...styles.metricButtonStyles, ...styles.metricImperialActiveButton }
                               : styles.metricButtonStyles

    const hoverImperialButtonClass = this.props.unitType !== UnitType.IMPERIAL && !isMobile ? 'hover-unit-button' : ''
    const hoverMetricButtonClass = this.props.unitType !== UnitType.METRIC && !isMobile ? 'hover-unit-button' : ''

    const displayMapLink = mapPresent

    return (
      <div className="container">
        <div className='row'>
          {
            // Left column cards
          }
          <div className={isMobile ? 'col-12' : 'col-4'}>
            <div style={styles.cardContainer}>
              <AthleteCard
                hideAddFriend={loggedIn && tokenRacerId === result.racerId}
                gender={gender}
                result={result}
                athleteId={result.racerId}
                homeTown={resultLocation}
                friends={friends}
                isFriend={isFriend}
                isMe={isMe}
                isMobile={isMobile}
                event={event}
                shouldShowFriends={shouldShowOnMobile()}
                isLoggedIn={loggedIn}
                isPublicProfile={result.isProfilePublic}
              />
            </div>
            {
              shouldShowOnMobile() &&
              <FriendsRacing
                type="IRP"
                isMobile={isMobile}
                event={event}
                athleteId={result.racerId}
              />
            }
            {
              !isMobile &&
              <Promo
                sponsors={sponsorLogos}
                adUnits={adUnits}
                isMobile={isMobile}
                t={t}
              />
            }
          </div>
          {
            // Right/main column cards
          }
          <div className={isMobile ? 'col-12' : 'col-8'}>
            <div className="col-12" style={styles.cardContainer} id='event-header-irp'>
              <EventHeader resultsUrl={resultsUrl} event={event} t={t} />
            </div>

            {displayMapLink ? this.renderMapTracking() : null}

            <div style={styles.cardContainer}>

              <div className="row">

                <div style={styles.raceName} className='col-12' id="irp-race-name">
                  <span>{result.raceName}</span>

                   <span style={{float: 'right'}}>
                    <Style>
                      {
                        styles.buttonHoverStyles()
                      }
                      <button onClick={this.onImperialViewClicked} className={hoverImperialButtonClass} style={imperialButtonStyles} type="button">MI</button>
                    </Style>
                    <Style>
                      {
                        styles.buttonHoverStyles()
                      }
                      <button onClick={this.onMetricViewClicked} className={hoverMetricButtonClass} style={metricButtonStyles} type="button">KM</button>
                    </Style>
                  </span>
                </div>

                <div className="col-12 col-sm-6">

                  <FinalTime
                    time={latestTime}
                    timeLabel={timeLabel}
                    pace={pace.value}
                    showPace={showRankings && shouldShowPace}
                    isMobile={isMobile}
                    paceUnits={pace.label}
                    raceName={result.raceName}
                    latestIntervalName={latestIntervalName}
                    t={t}
                  />
                  {
                    showRankings &&
                    <div style={isMobile ? {marginBottom: 35} : null} id="hero-card-all-division">
                      <HeroCardAllDivisions
                        title={this.getRankingTitle()}
                        rankings={this.getLatestRankings()}
                        isUnranked={isUnranked(entryStatus)}
                        t={t}
                      />
                    </div>
                  }
                </div>
                <div className="col-12 col-sm-6" style={!isMobile ? {paddingLeft: 40} : {}} id="race-summary">

                  <RaceSummary
                    altTime={altTime}
                    distance={distance}
                    startTime={this.getStartTime(result)}
                    event={event}
                    isGunTime={usingGunTime} // TODO: do we need the athlete confirmed check?
                    thirdParty={!!result.thirdPartyEntryId}
                    t={t}
                  />
                  <div className='row'>
                    <div className="col-9" id='claim-result'>
                      {
                        !entryIsTeam &&
                        <div>
                          <ClaimResultButton {...claimButtonProps} />
                          {
                            claimStatus && claimStatus !== 'Claimed' &&
                            <div style={styles.claimDescription}>
                              {getClaimStatusMessage(claimStatus, t)}
                              <Tooltip
                                icon={<HelpIcon style={styles.claimTooltipIcon}/>}
                                tip={{
                                  id: `${claimStatus}-tooltip`,
                                  content: getClaimStatusDescription(claimStatus, t)
                                }}
                                style={styles.claimTooltip}
                              />
                            </div>
                          }
                        </div>
                      }
                    </div>
                    <div className="col-3 px-0">
                      <StandardHeaderTags
                        title={ogTitle}
                        description={ogDescription}
                      />
                      <OpenGraphTags
                        ogType='website'
                        title={ogTitle}
                        description={ogDescription}
                        {...ogImage}
                      />
                      <SocialShare
                        buttonsProps={buttonsProps}
                        isMobile={isMobile}
                        useFbIcon={true}
                        location="IRP"
                        socialShareIconStyle={{padding: '7px 12px 11px 13px'}}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* End Timing Card */}
            <div style={styles.cardContainer}>
              {
                !isDQ(entryStatus) &&
                <div style={{backgroundColor: 'white'}}>
                  <h3 style={splitTable.title}>
                    {t('Race Splits')}
                  </h3>
                  <IRPRaceDetails
                    entryStatus={result.entryStatus}
                    intervals={result.intervals}
                    isLoading={this.props.isLoading}
                    isMobile={isMobile}
                    t={t}
                  />
                </div>
              }
            </div>
            {
              certificateUrl.url ?
              <IndividualPhotoGrid
                event={{photoServiceType: 'Free'}}
                result={result}
                isMobile={isMobile}
                certificateUrl={certificateUrl.url}
              /> :
              <div style={styles.cardContainer}>
                <NoCert t={t} isLoading={certificateUrl.fetching} error={certificateUrl.error} />
              </div>
            }
            <IndividualPhotoGrid
              event={event}
              result={result}
              isMobile={isMobile}
              media={media}
              mediaIsLoading={mediaIsLoading}
            />
            {
              isMobile &&
              <Promo
                sponsors={sponsorLogos}
                adUnits={adUnits}
                isMobile={isMobile}
                t={t}
              />
            }
          </div>
        </div>
        {
          isMobile && result && !result.racerId &&
          <div style={styles.stickyButton(isMobile)}>
            <ClaimResultButton {...claimButtonProps} isStickyButton={true} />
          </div>
        }
      </div>
    );
  }

}

export const IRPBodyContainer = compose(
  connect(mapStateToProps),
  withTranslation(),
  connectStream({
    friends: () => getFollowersStream('followers', getTokenRacerId()),
    splitsContent: () => EventResultsStreams.getLegacyEntryResult(),
    certificateUrl: ({result}) => getFinisherCertificateUrl(result.entryId, result.thirdPartyEntryId),
    pendingClaims: getPendingClaims,
    athleteRaces: () => getAthleteRacesStream(getTokenRacerId())
  })
)(IRPBodyContainerComponent);

const NoCert = ({t, isLoading, error}) => {
  return (
    <div>
      <h3 style={{fontWeight: 400, margin: '0px 0px 20px'}}>
        {t('Finisher Certificate')}
      </h3>
      {
        !isLoading ?
        <div style={{textAlign: 'center', marginTop: 25, height: 70, color: '#9b9b9b'}}>
          {t(error)}
        </div> :
        <div style={{width: '100%', marginTop: 25, height: 70}}>
          <Loading noTimeout={true} />
        </div>
      }
    </div>
  );
};




/** WEBPACK FOOTER **
 ** ./components/IRP/body/IRPBodyContainer.js
 **/